<template>
    <div class="section-products row g-2 g-lg-3">
        <div class="col-12 mt-0">
            <div class="d-flex flex-wrap home-product-types-filter justify-content-between">
                <div v-for="(type) in types" :key="type.id" class="d-flex">
                    <input type="checkbox" class="btn-check" :id="type.slug" :value="type.slug" v-model="selected.type" :key="type.id" @change="filterProducts" autocomplete="off">
                    <label class="flex-fill bg-light border rounded py-2 px-2 text-center my-1 small text-uppercase fw-semibold" :for="type.slug">{{ type.name[lang] }}</label>
                </div>
                <div class="d-flex">
                    <a href="/search" class="flex-fill bg-primary text-white border border-primary rounded py-2 px-2 text-center my-1 small text-uppercase fw-semibold">
                        {{ $t('messages.seeallactivities') }}</a>
                </div>
            </div>
        </div>
        <div v-for="product in products" :key="product.id" class="col-20">
            <div class="card shadow-sm product-card mb-4">
                <img :src="cdn_url+'products/'+product.image+'?auto=format,enhance,compress&fit=crop&crop=faces&h=200&w=260'" class="card-img-top" alt="" />
                <div class="card-body p-2 p-lg-3 pb-0 pb-lg-0">
                    <span v-if="product.type_name" class="text-uppercase small fw-bold text-secondary">{{ product.type_name[lang] }}</span>
                    <a :href="'/'+lang+'/t/'+product.type+'/'+product.id+'/'+product.slug" class="product-title stretched-link">{{ product.title[lang] }}</a>
                </div>
                <div class="card-bottom d-md-flex justify-content-between px-2 pb-2 px-lg-3 pb-lg-3">
                    <div class="product-price mt-auto">
                        <div class="text-muted small">{{ $t('messages.startingfrom') }}</div>
                        <span v-if="product.sale_price > 0" class="fw-bold text-color-secondary fs-5">{{ product.sale_price }} &euro;</span>
                        <span v-else class="fw-bold fs-5">{{ product.price }} &euro;</span>
                        <span v-if="product.sale_price > 0" class="fs-5 price-old">{{ product.price }} &euro;</span>
                    </div>
                    <div class="product-rating rating-stars d-none d-md-block mt-auto pb-1">
                        <review-ratings v-if="website_review != 0" :rating="product.rating_average"></review-ratings>
                        <div v-if="product.rating_average > 0" class="small"><strong>{{ product.rating_average }}</strong> ({{ product.reviews_count }} {{ $t('messages.reviews') }})</div>
                        <div v-else class="small">{{ $t('messages.Noreviewsyet') }}</div>
                    </div>
                </div>
            </div>
        </div>
        <infinite-loading :identifier="infiniteId" @infinite="latestProducts">
            <template #spinner>
                <div class="text-center">
                    {{ $t('messages.loading') }}...
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;background:transparent;display:block;" width="5rem" height="5rem" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                        <circle cx="50" cy="50" r="30" stroke="#303297" stroke-width="10" fill="none"></circle>
                        <circle cx="50" cy="50" r="30" stroke="#ff4d50" stroke-width="8" stroke-linecap="round" fill="none">
                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;180 50 50;720 50 50" keyTimes="0;0.5;1"></animateTransform>
                        <animate attributeName="stroke-dasharray" repeatCount="indefinite" dur="1s" values="18.84955592153876 169.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 169.64600329384882" keyTimes="0;0.5;1"></animate>
                        </circle>
                    </svg>
                </div>
            </template>
            <template #complete>
                <div class="text-center">
                    <a :href="route_search" class="btn my-5 btn-lg button-primary button-outline shadow py-3 ps-5 pe-4 rounded-pill">
                        <span class="fw-500">{{ $t('messages.seeallactivities') }}</span>
                        <i class="bi bi-arrow-right ms-4"></i>
                    </a>
                </div>
            </template>
        </infinite-loading>
    </div>
</template>

<script>
export default {
    props: {
        lang: String,
        website_id: String,
        website_review: String,
        route_search: String
    },

    data() {
        return {
            products: [],
            page: 1,
            types: [],
            selected: {
                type: []
            },
            infiniteId: +new Date(),
            cdn_url: process.env.MIX_CDN_URL
        }
    },

    methods: {
        latestProducts($state)  {
            axios.get(process.env.MIX_API_URL+'/'+this.website_id+'/home-with-pagination', {
                params: {
                    page: this.page,
                    type: this.selected.type,
                },
            }).then(({ data }) => {
                if (data.latest_products.data.length) {
                    this.page += 1;
                    this.products.push(...data.latest_products.data);
                    this.types = data.product_types;
                    $state.loaded();
                } else {
                    $state.complete();
                }
            });
        },

        filterProducts() {
            this.page = 1;
            this.products = [];
            this.infiniteId += 1;
        },

        takeToSearch() {
            window.location.href = this.route_search
        }
    }

}
</script>